import React from 'react';
import { Link } from 'react-router-dom';
import { Sprout, Trophy, Phone } from 'lucide-react';
interface ClassTimeCardProps {
  ageLabel: string;
  title: string;
  time: string;
  days: string;
  icon: React.ElementType;
}
function ClassTimeCard({
  ageLabel,
  title,
  time,
  days,
  icon: Icon
}: ClassTimeCardProps) {
  return <div className="bg-off-white border border-subtle-gray rounded-2xl p-6 flex flex-col gap-2" data-id="element-1874">
      <div className="flex items-center gap-3" data-id="element-1875">
        <div className="w-10 h-10 rounded-xl bg-storm-red/10 flex items-center justify-center text-storm-red" data-id="element-1876">
          <Icon className="w-5 h-5" data-id="element-1877" />
        </div>
        <div data-id="element-1878">
          <p className="text-xs uppercase tracking-wide text-gray-warm font-bold" data-id="element-1879">
            {ageLabel}
          </p>
          <h3 className="text-lg text-ink leading-tight" data-id="element-1880">{title}</h3>
        </div>
      </div>
      <p className="text-ink font-bold pt-2" data-id="element-1881">{time}</p>
      <p className="text-gray-warm text-sm" data-id="element-1882">{days}</p>
    </div>;
}
export function KidsClassTimes() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-1883">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1884">
        <div className="text-center mb-12" data-id="element-1885">
          <div className="inline-flex items-center gap-2 bg-storm-red/10 text-storm-red px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-1886">
            <Sprout className="w-3.5 h-3.5" data-id="element-1887" />
            Class Times
          </div>
          <h2 className="text-4xl md:text-5xl text-ink mb-4" data-id="element-1888">
            Kids Class Times
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-1889">
            Weekday after-school schedules built for families.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-1890">
          <ClassTimeCard ageLabel="Ages 3–5" title="Mini Troopers" time="4:30 PM – 5:00 PM" days="Monday – Friday" icon={Sprout} data-id="element-1891" />
          <ClassTimeCard ageLabel="Ages 6+" title="Kids Taekwondo · Early" time="5:00 PM – 6:00 PM" days="Monday – Friday" icon={Trophy} data-id="element-1892" />
          <ClassTimeCard ageLabel="Ages 6+" title="Kids Taekwondo · Late" time="6:00 PM – 7:00 PM" days="Monday – Friday" icon={Trophy} data-id="element-1893" />
          <div className="bg-ink text-off-white rounded-2xl p-6 flex flex-col gap-3 justify-center" data-id="element-1894">
            <p className="text-sm uppercase tracking-wide text-storm-red font-bold" data-id="element-1895">
              Not Sure Which Class?
            </p>
            <p className="text-off-white/90" data-id="element-1896">
              Tell us your child's age and we'll recommend the right starting
              class before your first visit.
            </p>
            <a href="tel:517-220-0621" className="text-white font-bold inline-flex items-center gap-2 hover:text-storm-red transition-colors" data-id="element-1897">
              <Phone className="w-4 h-4" data-id="element-1898" />
              Call 517-220-0621
            </a>
          </div>
        </div>

        <div className="text-center" data-id="element-1899">
          <Link to="/SignMeUp" className="btn-primary" data-id="element-1900">
            Start With a Trial Class
          </Link>
        </div>
      </div>
    </section>;
}